module.exports = __webpack_public_path__ + "img/pink.f34cb3e3.webp";